import { createContext, FC, ReactNode, useMemo } from 'react';

import { useFullscreen, UseFullscreenReturn } from 'src/hooks/useFullscreen';
import { useRequiredContext } from 'src/hooks/useRequiredContext';

export const FullscreenContext = createContext<UseFullscreenReturn | undefined>(
  undefined,
);
FullscreenContext.displayName = 'FullscreenContext';

interface FullscreenProviderProps {
  children?: ReactNode;
}

export const FullscreenProvider: FC<FullscreenProviderProps> = ({
  children,
}) => {
  const value = useFullscreen();

  const contextValue = useMemo((): UseFullscreenReturn => value, [value]);

  return (
    <FullscreenContext.Provider value={contextValue}>
      {children}
    </FullscreenContext.Provider>
  );
};

export const useFullscreenElement = (): UseFullscreenReturn =>
  useRequiredContext(FullscreenContext);
